import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentUser: {},
    currentUserData: {},
    onboardingComplete: false,
  },
  getters: {
    isLoggedIn: (state) => Boolean(state.currentUser.uid),
    isOnboarded: (state) => Boolean(state.onboardingComplete),
    currentUserData: (state) => state.currentUserData,
  },
  mutations: {
    SET_CURRENT_USER(state, currentUser) {
      state.currentUser = currentUser;
    },
    SET_CURRENT_USER_DATA(state, currentUserData) {
      state.currentUserData = currentUserData;
    },
    SET_ONBOARDING(state, onboardingComplete) {
      state.onboardingComplete = onboardingComplete;
    },
  },
  actions: {
    setCurrentUser({ commit }, currentUser) {
      if (!currentUser) {
        commit("SET_CURRENT_USER", {});
        commit("SET_CURRENT_USER_DATA", {});
        commit("SET_ONBOARDING", false);
      } else {
        commit("SET_CURRENT_USER", currentUser);
      }
    },
    setCurrentUserData({ commit }, currentUserData) {
      commit("SET_CURRENT_USER_DATA", currentUserData);
    },
    setOnboarded({ commit }, onboardingComplete) {
      commit("SET_ONBOARDING", onboardingComplete);
    },
  },
  modules: {},
});
